import { defineComponent as s, h as o, toRef as t } from "vue";
import a from "./highrise1770.mjs";
import i from "./highrise1073.mjs";
import { resolveSlot as n } from "./highrise1059.mjs";
import c from "./highrise1101.mjs";
import u from "./highrise1104.mjs";
import d from "./highrise1625.mjs";
const _ = s({
  name: "BaseClear",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    show: Boolean,
    onClear: Function
  },
  setup(e) {
    return c("-base-clear", a, t(e, "clsPrefix")), {
      handleMouseDown(r) {
        r.preventDefault();
      }
    };
  },
  render() {
    const {
      clsPrefix: e
    } = this;
    return o("div", {
      class: `${e}-base-clear`
    }, o(i, null, {
      default: () => {
        var r, l;
        return this.show ? o("div", {
          key: "dismiss",
          class: `${e}-base-clear__clear`,
          onClick: this.onClear,
          onMousedown: this.handleMouseDown,
          "data-clear": !0
        }, n(this.$slots.icon, () => [o(u, {
          clsPrefix: e
        }, {
          default: () => o(d, null)
        })])) : o("div", {
          key: "icon",
          class: `${e}-base-clear__placeholder`
        }, (l = (r = this.$slots).placeholder) === null || l === void 0 ? void 0 : l.call(r));
      }
    }));
  }
});
export {
  _ as default
};
